import { useNavigate } from "react-router-dom";
import GenericFormHeader from "../../components/dms_common/GenericFormHeader";
import "./createSaleReturns.css"
import { useEffect, useRef, useState } from "react";
import { Autocomplete, Box, Button, FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField, TextFieldProps } from "@mui/material";
import { clearBatchDetailsInDb, fetchAndSaveProductDetails, getInvoiceDetails, getReturnableInvoiceDetails, getReturnDetails, getTaxDetails, getRouteOutletList } from "../SalesReturn/SalesReturnService";
import { CreateSaleReturnFormData, ReturnableInvoiceDetails, SalesDetail } from "../../types/types";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { Loader } from "../../components/loader/Loader";
import { convertToMaxQty, getNqQuantity } from "../stocks/manualStockAdjustment/ManualStockAdjustmentUtils";
import { getOutletDetailsMap } from "../deliveryConfirmation/DeliveryConfirmationService";
import { AnyARecord } from "dns";
import { getDataFromLocalDb } from "../../services/dbService";
import { Product } from "../createSecondaryOrder/models";
import { getMergedCatalogueAndRealTimeStockData } from "../stocks/RealTimeStock/RealTimeStockUtils";


export const CreateSaleReturns = () => {

    const {fetchPricingBySalesrep, showSalesReturnWithInvoice} = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
    const navigate = useNavigate();
    const [disabled, setDisabled] = useState(true);
    const [withInvoice, setWithInvoice] = useState<string>(showSalesReturnWithInvoice ? "true" : "false");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [invoiceDetails, setInvoiceDetails] = useState<ReturnableInvoiceDetails[]>([]);
    const [allInvoiceDetails, setAllInvoiceDetails] = useState<ReturnableInvoiceDetails[]>([]);
    const [availableDeliveryDates, setAvailableDeliveryDates] = useState<Dayjs[]>([]);
    const [availableCreationTimes, setAvailableCreationTimes] = useState<Dayjs[]>([]);
    const [invoiceNumbers, setInvoiceNumbers] = useState<string[]>([]);
    const [formData, setFormData] = useState<CreateSaleReturnFormData>({
        outletCode: "",
        outletName: "",
        invoiceNumber: "",
        invoiceSerialNumber:"",
        deliveryDate: "",
        creationTime: "",
        salesMan: "",
        salesManName:"",
        RouteIdAndName:""
    });
    const [outletCodeOptions, setOutletCodeOptions] = useState<string[]>([]);
    const [salesManOptions, setSalesManOptions] = useState<string[]>([]);
    const [salesManNameOptions, setSalesManNameOptions] = useState<string[]>([]);
    const [outletNameOptions, setOutletNameOptions] = useState<string[]>([]);
    const [routeIdAndNameOptions, setRouteIdAndNameOptions] = useState<{[key: string]: any}>({});
    const [routeIdAndSalesManCode, setRouteIdAndSalesManCode] = useState<{[key: string]: any}>({});
    const [withInvoiceBeat, setWithInvoiceBeat] = useState<any>();
    const [withoutInvoiceBeat, setWithoutInvoiceBeat] = useState<any>();
    const outletCodeMap = useRef<{ [key: string]: any }>();
    const outletNameMap = useRef<{ [key: string]: any }>();
    const salesManNameMap= useRef<{ [key: string]: any }>();
    const salesManIdMap= useRef<{ [key: string]: any }>();
    const allowBatchId = useRef<boolean>(true);
    const [invoiceSerialNo,setInvoiceSerialNo] = useState<string[]>([]);

    const fetchData = async () => {
        const { outletCodeDetails, outletNameDetails, returnableData, withInvoiceRouteMap, outletSalesManNameDetails, outletSalesManIdDetails, withoutInvoiceRouteMap, routeIdAndSalesManCodeMap} = await getReturnableInvoiceDetails(fetchPricingBySalesrep);
        outletCodeMap.current = outletCodeDetails;
        outletNameMap.current = outletNameDetails;
        salesManNameMap.current = outletSalesManNameDetails;
        salesManIdMap.current = outletSalesManIdDetails;
        setRouteIdAndSalesManCode(routeIdAndSalesManCodeMap)
        setInvoiceDetails(returnableData);
        setAllInvoiceDetails(returnableData);
        setWithInvoiceBeat(withInvoiceRouteMap);
        setWithoutInvoiceBeat(withoutInvoiceRouteMap);
        setIsLoading(false);
        allowBatchId.current = localStorage.getItem("showBatchId") !== "false";
        if(!fetchPricingBySalesrep){
            if(withInvoice == "true"){
                // Filter out inactive outlets even for "with invoice" mode
                setOutletNameOptions(Array.from(new Set(returnableData.map(invoice => invoice.outletName).filter(outletName => outletNameDetails?.[outletName] && outletNameDetails[outletName].activeStatus !== 'inactive'))));
                setOutletCodeOptions(Array.from(new Set(returnableData.map(invoice => invoice.outletCode).filter(outletCode => outletCodeDetails?.[outletCode] && outletCodeDetails[outletCode].activeStatus !== 'inactive'))));
            }else{
                // Filter out inactive outlets
                const activeOutletCodes = Object.keys(outletCodeDetails ?? {}).filter(code => 
                    outletCodeDetails[code]?.activeStatus !== 'inactive'
                );
                const activeOutletNames = Object.keys(outletNameDetails ?? {}).filter(name => 
                    outletNameDetails[name]?.activeStatus !== 'inactive'
                );
                
                setOutletNameOptions(activeOutletNames);
                setOutletCodeOptions(activeOutletCodes);
            }
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    useEffect(()=>{
        if(withInvoice == "true"){
            setRouteIdAndNameOptions(withInvoiceBeat ?? {});
        }else{
            setRouteIdAndNameOptions(withoutInvoiceBeat ?? {});
        }
    }, [withInvoice, withInvoiceBeat, withoutInvoiceBeat])
    

    const handleRouteChange = async (routeIdName: string) => {
        const routeObjArr = routeIdAndNameOptions[routeIdName] as any | undefined;
        const routeId = routeObjArr.routeId ?? "";

        setFormData({
            outletCode: "",
            outletName: "",
            deliveryDate: "",
            invoiceNumber: "",
            invoiceSerialNumber:"",
            creationTime: "",
            salesMan: "",
            salesManName: "",
            RouteIdAndName: routeIdName
        });

        
        setOutletNameOptions([]);
        setOutletCodeOptions([]);
        setSalesManOptions([]);
        setSalesManNameOptions([]);
        setAvailableDeliveryDates([]);
        setAvailableCreationTimes([]);
        // setInvoiceNumbers([]);
        setInvoiceSerialNo([]);


        const filteredInvoices = allInvoiceDetails.filter((inv: any) => inv.routeId!= "" && routeId === inv.routeId);

        if(fetchPricingBySalesrep){
            if(withInvoice === "true") {
                setSalesManOptions(Array.from(new Set(
                    filteredInvoices
                        .map((inv: any) => inv.salesMan)
                        .filter(salesMan => salesMan && salesManIdMap.current?.[salesMan])
                )));
                setSalesManNameOptions(Array.from(new Set(
                    filteredInvoices
                        .map((inv: any) => inv.salesManName.name)
                        .filter(salesManName => salesManName && salesManNameMap.current?.[salesManName])
                )));
            } else {
                const salesManId = withoutInvoiceBeat[routeIdName] ? [withoutInvoiceBeat[routeIdName]] : [];
                setSalesManOptions(salesManId);
                const newSalesManNameOptions: any[] = [];
                salesManId.forEach((salesManId: any) => {
                    if (salesManId && salesManIdMap.current?.[salesManId]) {
                        newSalesManNameOptions.push(salesManIdMap.current[salesManId].name || "");
                    }
                });
                setSalesManNameOptions(newSalesManNameOptions ?? {});
            }
        } else {
            if (withInvoice === "true") {
                // Filter out inactive outlets
                setOutletNameOptions(Array.from(new Set(
                    filteredInvoices
                        .map(inv => inv.outletName)
                        .filter(name => outletNameMap.current?.[name] && outletNameMap.current[name].activeStatus !== 'inactive')
                )));
                setOutletCodeOptions(Array.from(new Set(
                    filteredInvoices
                        .map(inv => inv.outletCode)
                        .filter(code => outletCodeMap.current?.[code] && outletCodeMap.current[code].activeStatus !== 'inactive')
                )));
            } else {
                // Filter out inactive outlets
                setOutletCodeOptions(Object.keys(outletCodeMap.current ?? {}).filter(code => code && outletCodeMap.current?.[code]?.activeStatus !== 'inactive'));
                setOutletNameOptions(Object.keys(outletNameMap.current ?? {}).filter(name => name && outletNameMap.current?.[name]?.activeStatus !== 'inactive'));
            }
        }
        setInvoiceDetails(filteredInvoices);

    };

    const handleSalesManChange = async(salesMan: string) => {
        const salesManName = salesManIdMap.current?.[salesMan].name || "";
       
        setOutletNameOptions([]);
        setOutletCodeOptions([]);
        
        setFormData({
            ...formData,    
            outletCode:"",
            outletName:"",
            deliveryDate: "",
            invoiceNumber: "",
            invoiceSerialNumber:"",
            creationTime: "",
            salesMan,
            salesManName: salesManName,
        })
        if(withInvoice == "true"){
            // Filter out inactive outlets
            setOutletNameOptions(Array.from(new Set(invoiceDetails.filter(invoice => invoice.salesMan == salesMan && outletNameMap.current?.[invoice.outletName] && outletNameMap.current[invoice.outletName].activeStatus !== 'inactive').map(invoice => invoice.outletName))));
            setOutletCodeOptions(Array.from(new Set(invoiceDetails.filter(invoice => invoice.salesMan == salesMan && outletCodeMap.current?.[invoice.outletCode] && outletCodeMap.current[invoice.outletCode].activeStatus !== 'inactive').map(invoice => invoice.outletCode))));
        }else{ 
            const outletDetails = await getOutletDetailsMap(undefined, salesMan);
            const routeId = formData.RouteIdAndName?.split("-").slice(0, 2).join("-") ?? "";
            const routeOutletList = await getRouteOutletList(routeId ?? "");
            const outletNameDetails: any = {};
            const outletCodeDetails: any = {};
            routeOutletList.forEach((key: any) => {
                const outlet = outletDetails[key];
                // Only include active outlets
                if (outlet && outlet.activeStatus !== 'inactive') {
                    outletCodeDetails[outlet.outletCode] = outlet;
                    outletNameDetails[outlet.outletName] = outlet;
                }
            })
            outletCodeMap.current = outletCodeDetails;
            outletNameMap.current = outletNameDetails;
            setOutletNameOptions(Object.keys(outletNameMap.current ?? {}));
            setOutletCodeOptions(Object.keys(outletCodeMap.current ?? {}));
        }

        setAvailableDeliveryDates([]);
        setAvailableCreationTimes([]);
        // setInvoiceNumbers([]);
        setInvoiceSerialNo([]);
    }

    const handleSalesManNameChange = async (salesManName: string) => {
        const salesManLoginId = salesManNameMap.current?.[salesManName].loginId || "";
        setOutletNameOptions([]);
        setOutletCodeOptions([]);
        setFormData({
            ...formData,
            outletCode: "",
            outletName: "",
            deliveryDate: "",
            invoiceNumber: "",
            invoiceSerialNumber:"",
            creationTime: "",
            salesMan: salesManLoginId,
            salesManName,
        })

        if (withInvoice == "true") {
            // Filter out inactive outlets
            setOutletNameOptions(Array.from(new Set(invoiceDetails.filter(invoice => invoice.salesManName == salesManName && outletNameMap.current?.[invoice.outletName] && outletNameMap.current[invoice.outletName].activeStatus !== 'inactive').map(invoice => invoice.outletName))));
            setOutletCodeOptions(Array.from(new Set(invoiceDetails.filter(invoice => invoice.salesMan == salesManLoginId && outletCodeMap.current?.[invoice.outletCode] && outletCodeMap.current[invoice.outletCode].activeStatus !== 'inactive').map(invoice => invoice.outletCode))));
        } else {
            const outletDetails = await getOutletDetailsMap(undefined, salesManLoginId);
            const routeId = formData.RouteIdAndName?.split("-").slice(0, 2).join("-") ?? "";
            const routeOutletList = await getRouteOutletList(routeId ?? "");
            const outletNameDetails: any = {};
            const outletCodeDetails: any = {};
            routeOutletList.forEach((key: any) => {
                const outlet = outletDetails[key];
                // Only include active outlets
                if (outlet && outlet.activeStatus !== 'inactive') {
                    outletCodeDetails[outlet.outletCode] = outlet;
                    outletNameDetails[outlet.outletName] = outlet;
                }
            })
            outletCodeMap.current = outletCodeDetails;
            outletNameMap.current = outletNameDetails;
            setOutletNameOptions(Object.keys(outletNameMap.current ?? {}));
            setOutletCodeOptions(Object.keys(outletCodeMap.current ?? {}));
        }
        setAvailableDeliveryDates([]);
        setAvailableCreationTimes([]);
        // setInvoiceNumbers([]);
        setInvoiceSerialNo([]);
    }

    const handleOutletCodeChange = (outletCode: string) => {
        const outletName = outletCodeMap.current?.[outletCode]?.outletName ?? "";
        setFormData({
            ...formData,
            outletCode,
            outletName,
            deliveryDate: "",
            invoiceNumber: "",
            invoiceSerialNumber:"",
            creationTime: "",
        })
        const filteredInvoices = invoiceDetails.filter(invoice =>
            invoice.outletCode === outletCode &&
            (!fetchPricingBySalesrep || invoice.salesMan === formData.salesMan) &&
            ((formData.RouteIdAndName && invoice.routeId) ? formData.RouteIdAndName.includes(invoice.routeId) : true)
        );
        const deliveryDates:Dayjs[] = Array.from(new Set(filteredInvoices.map(invoice => invoice.deliveryDate))).map(date => dayjs(date,"DD-MM-YYYY"));
        const creationTimes: Dayjs[] = Array.from(new Set(
        filteredInvoices
            .filter(invoice => invoice.creationTime).map(invoice => dayjs(invoice.creationTime,"DD-MM-YYYY"))
        ))
        setAvailableDeliveryDates(deliveryDates);
        setAvailableCreationTimes(creationTimes);
        // setInvoiceNumbers(filteredInvoices.map(invoice => invoice.invoiceNumber));
        setInvoiceSerialNo(filteredInvoices.map(invoice => invoice.inv_ser_no || invoice.invoiceNumber))
    }

    const handleOutletNameChange = (outletName: string) => {
        const outletCode = outletNameMap.current?.[outletName]?.outletCode ?? "";
        setFormData({
            ...formData,
            outletCode,
            outletName,
            deliveryDate: "",
            invoiceNumber: "",
            invoiceSerialNumber:"",
            creationTime: "",
        })
        const filteredInvoices = invoiceDetails.filter(invoice =>
            invoice.outletName === outletName &&
            (!fetchPricingBySalesrep || invoice.salesMan === formData.salesMan) && 
            ((formData.RouteIdAndName && invoice.routeId) ? formData.RouteIdAndName.includes(invoice.routeId) : true)
        );
        const deliveryDates:Dayjs[] = Array.from(new Set(filteredInvoices.map(invoice => invoice.deliveryDate))).map(date => dayjs(date,"DD-MM-YYYY"));
        const creationTimes: Dayjs[] = Array.from(new Set(
        filteredInvoices
            .filter(invoice => invoice.creationTime)
            .map(invoice => dayjs(invoice.creationTime,"DD-MM-YYYY"))
        ))
        setAvailableDeliveryDates(deliveryDates);
        setAvailableCreationTimes(creationTimes);
        // setInvoiceNumbers(filteredInvoices.map(invoice => invoice.invoiceNumber));
        setInvoiceSerialNo(filteredInvoices.map(invoice => invoice.inv_ser_no || invoice.invoiceNumber))
    }
    const handleInvoiceNumberChange = (invoiceSerialNumber: string) => {
        const invoice = invoiceDetails.find(invoice => invoice.inv_ser_no == invoiceSerialNumber);
        setFormData({
            ...formData,
            invoiceNumber: invoice?.invoiceNumber ?? "",
            invoiceSerialNumber:invoice?.inv_ser_no ?? "",
            deliveryDate: invoice?.deliveryDate ?? "",
            creationTime: invoice?.creationTime ?? "",
        })
    }

    const handleDeliveryDateChange = (updatedDeliveryDate: Dayjs | null) => {
        const deliveryDate = updatedDeliveryDate?.format("DD-MM-YYYY") ?? "";
        // filter on sales rep
        const filteredInvoices = updatedDeliveryDate ? invoiceDetails.filter(invoice=>invoice.outletCode == formData.outletCode && invoice.deliveryDate == deliveryDate && invoice.salesMan== formData.salesMan) : invoiceDetails.filter(invoice=>invoice.salesMan== formData.salesMan);
        // setInvoiceNumbers(filteredInvoices.map(invoice => invoice.invoiceNumber));
        setInvoiceSerialNo(filteredInvoices.map(invoice => invoice.inv_ser_no || invoice.invoiceNumber))
        setFormData({
            ...formData,
            invoiceNumber: "",
            invoiceSerialNumber:"",
            deliveryDate,
            creationTime: "",
        });
        
    }
    const handleCreationTimeChange = (updatedCreationTime: Dayjs | null) => {
        const creationTime = updatedCreationTime?.format("DD-MM-YYYY") ?? "";
        //formData change-might
        //but invoice should change
        // filter on salesrep
        const filteredInvoices = invoiceDetails.filter(invoice=>invoice.outletCode == formData.outletCode && invoice.salesMan== formData.salesMan && (updatedCreationTime ? invoice.creationTime == creationTime : true));
        // setInvoiceNumbers(filteredInvoices.map(invoice => invoice.invoiceNumber)); //invoiceSerialNumber
        setInvoiceSerialNo(filteredInvoices.map(invoice => invoice.inv_ser_no || invoice.invoiceNumber));
        setFormData({
            ...formData,
            invoiceNumber: "",
            invoiceSerialNumber:"",
            deliveryDate:"",
            creationTime,
        });

    }

    const openCreateSaleReturnWithInvioce = async() => {
        setDisabled(true);
        try{
            await clearBatchDetailsInDb("salesReturnWithInvoice");
            const productData = await fetchAndSaveProductDetails(formData.outletCode, false, formData.salesMan ?? "" );
            const invoiceDetails : any = await getInvoiceDetails(formData.invoiceNumber, productData);
            invoiceDetails.accountType = outletCodeMap.current?.[invoiceDetails.outletCode]?.keyAccount ? "Key Account" : "Non-Key Account";
            invoiceDetails.outletName = outletCodeMap.current?.[invoiceDetails.outletCode]?.outletName ?? "";
            
            const productsData = await getDataFromLocalDb("Product");
            const productsMap: Record<string, Product> = productsData?.data?.[0]?.data ?? {};
            const newInvoiceDetails = getMergedCatalogueAndRealTimeStockData(
                invoiceDetails.salesDetails,
                productsMap
            );
            invoiceDetails.salesDetails= newInvoiceDetails;
            invoiceDetails.salesDetails.forEach((salesDetail:any)=>{
                salesDetail.netAmount = 0;
            })
            //for getting net data subtractted with return qty
            const returnBatchDetails  = await returnableInvoiceDetailsData(invoiceDetails); 
            await clearBatchDetailsInDb("salesReturnWithInvoice");
            const taxDetails = await getTaxDetails(invoiceDetails.outletCode, invoiceDetails.supplier, invoiceDetails.salesDetails.map((salesDetail:SalesDetail)=>salesDetail.batchCode));
            
            navigate("invoice/skuSelection",{state:{
                invoiceDetails,
                taxDetails,
                returnBatchDetails,
                allowBatchId:allowBatchId.current
            }})
        }catch(e){
            openPopup("Error", "Unable to create sale return, please try again");
            console.error(e);
        }
        setDisabled(false);
    }

const returnableInvoiceDetailsData = async (invoiceData: any) => {
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
    const batchIdConfiguration = ConfigDictionary?.batchIdConfiguration;

    const returnBatchDetails = await getReturnDetails(invoiceData.invoiceNumber);
    for (const salesDetails of invoiceData.salesDetails) {
        const tempData = {
            totalCaseQty: salesDetails.initialCaseQuantity,
            totalPieceQty: salesDetails.initialPieceQuantity,
            totalOtherQty: salesDetails.initialOtherUnitQuantity,
            skuCode: salesDetails.batchCode,
        }

        const normalizedQty = await getNqQuantity(tempData, salesDetails.productDetails);

        let returnQtyForThisBatch = returnBatchDetails.skuDetailsSummary[salesDetails.batchCode + (batchIdConfiguration ? "_" + salesDetails.batchId : "")] ?? 0;
        const newNormalizedQty = normalizedQty - returnQtyForThisBatch;

        const quantityObj = {
            totalCaseQty: 0,
            totalPieceQty: Math.max(0, newNormalizedQty),
            totalOtherQty: 0,
            skuCode: salesDetails.batchCode,
        };

        const newQuantityObj = await convertToMaxQty(quantityObj, salesDetails.batchCode, "all");

        salesDetails.soldCaseQty = newQuantityObj.totalCaseQty;
        salesDetails.soldPieceQty = newQuantityObj.totalPieceQty;
        salesDetails.soldOtherQty = newQuantityObj.totalOtherQty;
        salesDetails.totalCaseQty = newQuantityObj.totalCaseQty;
        salesDetails.totalPieceQty = newQuantityObj.totalPieceQty;
        salesDetails.totalOtherQty = newQuantityObj.totalOtherQty;

        if (salesDetails.batchIds && salesDetails.batchIds.length > 0) {
            for (const batchId of salesDetails.batchIds) {
                const tempBatchObj = {
                    skuCode: salesDetails.batchCode,
                    totalCaseQty: batchId.caseQty,
                    totalPieceQty: batchId.pieceQty,
                    totalOtherQty: batchId.otherQty,
                }
                const normalizedBatchQty = await getNqQuantity(tempBatchObj, salesDetails.productDetails);
                
                const returnQty = returnBatchDetails?.batchDetails?.[salesDetails.batchCode + "_" + batchId.batchId] ?? 0;

                const newBatchQty = normalizedBatchQty - returnQty;
                
                const batchQtyObj = {
                    totalCaseQty: 0,
                    totalPieceQty: Math.max(0, newBatchQty),
                    totalOtherQty: 0,
                    skuCode: salesDetails.batchCode,
                };
                
                const newBatchQtyObj = await convertToMaxQty(batchQtyObj, salesDetails.batchCode, "all");
                batchId.caseQty = newBatchQtyObj.totalCaseQty;
                batchId.pieceQty = newBatchQtyObj.totalPieceQty;
                batchId.otherQty = newBatchQtyObj.totalOtherQty;
            }
        }
    }
    return returnBatchDetails;
}

const openCreateSaleReturnWithoutInvioce = async() => {
        setDisabled(true);
        try{
            await clearBatchDetailsInDb();
            const outletDetails=outletCodeMap.current?.[formData.outletCode];
            await fetchAndSaveProductDetails(formData.outletCode, true, formData.salesMan);
            outletDetails.salesRepId = formData.salesMan ? formData.salesMan : null;
            outletDetails.salesRepName = formData.salesManName ? formData.salesManName : null;
            navigate("skuSelection",{state:{
                outletDetails,
                allowBatchId:allowBatchId.current
            }})
        }catch(e){
            openPopup("Error", "Unable to create sale return, please try again");
            console.error(e);
        }
        setDisabled(false);
    }

    useEffect(() => {
        const isValid = formData.outletCode && 
                    (!fetchPricingBySalesrep || (formData.salesMan && formData.salesManName && formData.RouteIdAndName)) &&
                    (withInvoice !== "true" || (formData.deliveryDate && formData.creationTime && formData.invoiceNumber));
        setDisabled(!isValid);
    }, [formData, withInvoice, fetchPricingBySalesrep]);

    useEffect(() => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if ((event.ctrlKey || event.metaKey) && event.key === 'a') {
      event.preventDefault();
      if (!disabled && !isLoading) {
        if (withInvoice === 'true') {
          openCreateSaleReturnWithInvioce();
        } else {
          openCreateSaleReturnWithoutInvioce();
        }
      }
    }
  };

  window.addEventListener('keydown', handleKeyDown);
  return () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
}, [withInvoice, disabled, isLoading, openCreateSaleReturnWithInvioce, openCreateSaleReturnWithoutInvioce]);

    const shouldDisableDate = (date:Dayjs) => {
        return !availableDeliveryDates.some(allowedDate => 
            allowedDate.format("DD-MM-YYYY") === date.format("DD-MM-YYYY")
        );
      };


      const handleInvoiceToggle=(e: React.ChangeEvent<HTMLInputElement>) => {
        setWithInvoice(e.target.value);
        setFormData({
            outletCode: "",
            outletName: "",
            invoiceNumber: "",
            invoiceSerialNumber:"",
            deliveryDate: "",
            salesMan: "",
            creationTime: "",
            salesManName: "",
            RouteIdAndName:""
        })
        if(e.target.value == "true"){
            // Filter out inactive outlets
            setOutletNameOptions(Array.from(new Set(invoiceDetails.map(invoice => invoice.outletName).filter(outletName => outletNameMap.current?.[outletName] && outletNameMap.current[outletName].activeStatus !== 'inactive'))));
            setOutletCodeOptions(Array.from(new Set(invoiceDetails.map(invoice => invoice.outletCode).filter(outletCode => outletCodeMap.current?.[outletCode] && outletCodeMap.current[outletCode].activeStatus !== 'inactive'))));
        }else{
            // Filter out inactive outlets
            setOutletNameOptions(Object.keys(outletNameMap.current ?? {}).filter(name => outletNameMap.current?.[name]?.activeStatus !== 'inactive'));
            setOutletCodeOptions(Object.keys(outletCodeMap.current ?? {}).filter(code => outletCodeMap.current?.[code]?.activeStatus !== 'inactive'));
        }
      }

    const shouldDisableCreationTime = (date: Dayjs) => {
        return !availableCreationTimes.some(allowedDate =>
            allowedDate.format("DD-MM-YYYY") === date.format("DD-MM-YYYY")
        );
    };
    return (
        <div className="create-sale-return-container">
            <GenericFormHeader
                labelDetails={[
                    {
                        label: "Sale Returns",
                        redirectFunction: () => {
                            navigate(-1);
                        }
                    },
                    {
                        label: "Create New Return"
                    }
                ]}
            />
            <div className="create-sale-return-form-container">
                {showSalesReturnWithInvoice && <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        Select Type <span style={{ color: "red" }}>*</span>
                    </div>
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            row
                            value={withInvoice}
                            onChange={handleInvoiceToggle}
                        >
                            <FormControlLabel className="create-sales-return-radio-label" value="true" control={<Radio className="create-sales-return-radio"/>} label="With Invoice" />
                            <FormControlLabel className="create-sales-return-radio-label" value="false" control={<Radio className="create-sales-return-radio"/>} label="Without Invoice" />
                        </RadioGroup>
                    </FormControl>

                </div>}
                {isLoading ? <Loader /> : <>
                {fetchPricingBySalesrep && <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        Route <span style={{ color: "red" }}>*</span>
                    </div>
                    <Autocomplete
                        disableClearable
                        options={Object.keys(routeIdAndNameOptions)}
                        getOptionLabel={(option) => option}
                        value={formData.RouteIdAndName}
                        onChange={(event, val) => handleRouteChange(val ?? "")}
                        sx={{ width: "-webkit-fill-available" }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="RouteName-Id"
                                variant="outlined"
                                placeholder="Enter Route"
                                size="small"
                                sx={customMuiInputStyle}
                                required
                            />
                        )}
                    />

                </div>}
                {fetchPricingBySalesrep && <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        SalesMan Id<span style={{ color: "red" }}>*</span>
                    </div>
                    <Autocomplete
                        disableClearable
                        options={salesManOptions}
                        getOptionLabel={(option) => option}
                        value={formData.salesMan}
                        onChange={(event, val) => handleSalesManChange(val ?? "")}
                        sx={{ width: "-webkit-fill-available" }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="salesMan"
                                variant="outlined"
                                placeholder="Enter Sales Man Id"
                                size="small"
                                sx={customMuiInputStyle}
                                required
                            />
                        )}
                    />

                </div>}
                {fetchPricingBySalesrep && <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        SalesMan Name<span style={{ color: "red" }}>*</span>
                    </div>
                    <Autocomplete
                        disableClearable
                        options={salesManNameOptions}
                        getOptionLabel={(option) => option}
                        value={formData.salesManName}
                        onChange={(event, val) => handleSalesManNameChange(val ?? "")}
                        sx={{ width: "-webkit-fill-available" }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="salesMan"
                                variant="outlined"
                                placeholder="Enter Sales Man Name"
                                size="small"
                                sx={customMuiInputStyle}
                                required
                            />
                        )}
                    />

                </div>}
                <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        Outlet Code <span style={{ color: "red" }}>*</span>
                    </div>
                    <Autocomplete
                        disableClearable
                        options={outletCodeOptions}
                        getOptionLabel={(option) => option}
                        value={formData.outletCode}
                        onChange={(event, val) => handleOutletCodeChange(val ?? "")}
                        sx={{ width: "-webkit-fill-available" }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="outletCode"
                                variant="outlined"
                                placeholder="Enter Outlet Code"
                                size="small"
                                sx={customMuiInputStyle}
                                required
                            />
                        )}
                    />

                </div>
                <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        Outlet Name <span style={{ color: "red" }}>*</span>
                    </div>
                    <Autocomplete
                        disableClearable
                        options={outletNameOptions}
                        getOptionLabel={(option) => option}
                        value={formData.outletName}
                        onChange={(event, val) => handleOutletNameChange(val ?? "")}
                        sx={{ width: "-webkit-fill-available" }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="outletName"
                                variant="outlined"
                                placeholder="Enter Outlet Name"
                                size="small"
                                sx={customMuiInputStyle}
                                required
                            />
                        )}
                    />

                </div>
                {withInvoice=="true" && <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        Invoice No. <span style={{ color: "red" }}>*</span>
                    </div>
                    <Autocomplete
                        disableClearable
                        options={invoiceSerialNo}
                        getOptionLabel={(option) => option}
                        value={formData.invoiceSerialNumber}
                        onChange={(event, val) => handleInvoiceNumberChange(val ?? "")}
                        sx={{ width: "-webkit-fill-available" }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                name="outletName"
                                variant="outlined"
                                placeholder="Enter Invoice No."
                                size="small"
                                sx={customMuiInputStyle}
                                required
                            />
                        )}
                    />
                </div>}
                {withInvoice=="true" && <div className="create-sale-return-form-field">
                    <div className="create-sale-return-form-field-label">
                        Delivery Date <span style={{ color: "red" }}>*</span>
                    </div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            value={formData.deliveryDate ? dayjs(formData.deliveryDate, "DD-MM-YYYY") : null}
                            shouldDisableDate={shouldDisableDate}
                            inputFormat="DD-MM-YYYY"
                            onChange={(newValue) => handleDeliveryDateChange(newValue)}
                            renderInput={(params) => (
                                <TextField {...params} size="small" fullWidth InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                      <>
                                        {formData.deliveryDate && (

                                            <FontAwesomeIcon
                                                        className="clear-sales-delivery-date-icon"
                                                            icon={faXmark}
                                                            onClick={() => handleDeliveryDateChange(null)}
                                                        />
                                        )}
                                        {params.InputProps?.endAdornment}
                                      </>
                                    ),
                                  }}/>
                            )}
                        />
                    </LocalizationProvider>
                </div>}
                    {withInvoice == "true" && <div className="create-sale-return-form-field">
                        <div className="create-sale-return-form-field-label">
                            Creation Date <span style={{ color: "red" }}>*</span>
                        </div>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                value={formData.creationTime ? dayjs(formData.creationTime, "DD-MM-YYYY") : null}
                                shouldDisableDate={shouldDisableCreationTime}
                                inputFormat="DD-MM-YYYY"
                                onChange={(newValue) => handleCreationTimeChange(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} size="small" fullWidth InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {formData.creationTime && (
                                                    <FontAwesomeIcon
                                                        className="clear-sales-delivery-date-icon"
                                                        icon={faXmark}
                                                        onClick={() => handleCreationTimeChange(null)}
                                                    />
                                                )}
                                                {params.InputProps?.endAdornment}
                                            </>
                                        ),
                                    }} />
                                )}
                            />
                        </LocalizationProvider>
                    </div>}
                <Box
                    mt={6}
                    display="flex"
                    justifyContent="right"
                    marginTop={"60px"}
                >
                    <Button
                        onClick={withInvoice == "true" ? openCreateSaleReturnWithInvioce : openCreateSaleReturnWithoutInvioce}
                        variant="contained"
                        disabled={disabled}
                        sx={{
                            backgroundColor: disabled ? "#E0E0E0" : "#20c6b1",
                            color: disabled ? "#A0A0A0" : "#FFFFFF"
                        }}
                    >
                        Save & Next
                    </Button>
                </Box>
                </>}
            </div>
        </div>
    );
}
const customMuiInputStyle = {
    "& .MuiOutlinedInput-root": {
        "& fieldset": {
            borderColor: "#EAEAEA",
        },
        "&:hover fieldset": {
            borderColor: "#B9B9B9",
        },
        "&.Mui-focused fieldset": {
            borderColor: "#1C7EA0",
        },
    },
    "& .MuiInputLabel-root": {
        color: "#B5B5B5",
        fontSize: "13px",
    },
    "& .MuiInputLabel-root.Mui-focused": {
        color: "#1C7EA0",
    },
};